import { RootState } from '../../../../redux/store';

export const selectSelectedSessionId = (state: RootState) => state.chatUi.selectedSessionId;
